import { render } from "./SchoolLegalEntityContent.vue?vue&type=template&id=720f4315&scoped=true&ts=true"
import script from "./SchoolLegalEntityContent.vue?vue&type=script&lang=ts"
export * from "./SchoolLegalEntityContent.vue?vue&type=script&lang=ts"

import "./SchoolLegalEntityContent.vue?vue&type=style&index=0&id=720f4315&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720f4315"]])

export default __exports__